import react from "react"
import Aos from "aos"
import "aos/dist/aos.css"
import "./social-feeds.css"
import { TwitterTimelineEmbed } from "react-twitter-embed"
import { database } from "../../../firebase"

const Feeds = () => {
  const [pdf, setpdf] = react.useState()

  function isPhone() {
    const width = window.innerWidth
    if (width < 600) {
      return true
    }
    return false
  }
  function twitter() {
    if (isPhone())
      return (
        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="csi_iitbhu"
          options={{ height: 400, width: 380 }}
        />
      )
    return (
      <TwitterTimelineEmbed
        sourceType="profile"
        screenName="csi_iitbhu"
        options={{ height: 400, width: 500 }}
      />
    )
  }
  react.useEffect(async () => {
    database.slides.orderBy("name", "asc").onSnapshot((querySnapshot) => {
      const arr1 = []
      querySnapshot.forEach((doc) => {
        const { URL } = doc.data()
        arr1.push(URL)
      })
      setpdf(arr1)
    })
  }, [])
  react.useEffect(() => {
    Aos.init({ duration: 1200 })
  }, [])
  return (
    <header className="feeds" data-aos="fade-up">
      <div className="container1">
        <div className="igfeeds">
          {/* <iframe src="https://twitter.com/csi_iitbhu" title="ig" id="ig">
            {" "}
          </iframe> */}
          {twitter()}
        </div>
        <div className="slides1">
          <iframe
            src={pdf}
            title="slides"
            id="view-slide"
            style={{ width: "80%" }}
          >
            {" "}
          </iframe>
        </div>
      </div>
    </header>
  )
}
export default Feeds
